import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiClient {

  private http: HttpClient = inject(HttpClient);

  public post<R, T>(url: string, body: R): Observable<T> {
    const fullUrl = `${environment.apiUrl}${url}`;
    return this.http.post<T>(fullUrl, body);
  }

  public get<T>(url: string): Observable<T> {
    const fullUrl = `${environment.apiUrl}${url}`;
    return this.http.get<T>(fullUrl);
  }

  public put<R, T>(url: string, body: R): Observable<T> {
    const fullUrl = `${environment.apiUrl}${url}`;
    return this.http.put<T>(fullUrl, body);
  }

  public delete<T>(url: string): Observable<T> {
    const fullUrl = `${environment.apiUrl}${url}`;
    return this.http.delete<T>(fullUrl);
  }
}
